import { Store } from "pullstate";
import { Node, Edge } from 'reactflow';
import { PagedList } from "../../../types/common";

//const savedNodes = localStorage.getItem('nodes');
//const savedEdges = localStorage.getItem('edges');

export const initialNodes: Node[] = [
    {
        id: crypto.randomUUID(),
        data: { value: 'Your question here' },
        position: { x: 0, y: 0 },
        type: 'questionNode',
    }
];

export const initialEdges: Edge[] = [];

console.log(initialNodes);
console.log(initialEdges);

export type Chat = {
    id: string,
    name: string,
    intent: string,
    isFunction: boolean,
    published: boolean,
    isDeleted: boolean,
    nodes: Node[],
    edges: Edge[],
    utterances: ChatUtterance[]
}

export type ChatUtterance = {
    id: string,
    text: string,
    isNew: boolean
}

export type ChatListItem = {
    id: string,
    name: string,
    published: boolean,
    isDeleted: boolean
}

export type FunctionListItem = {
    id: string,
    name: string,
    published: boolean,
    isDeleted: boolean
}

const NodeStore = new Store({
    chats: {
        pageNumber: 1,
        pageSize: 10,
        hasNextPage: false,
        totalCount: 0,
        totalPages: 0,
        items: []
    } as PagedList<ChatListItem>,
    functions: [] as FunctionListItem[],
    chat: {
        id: crypto.randomUUID(),
        name: '',
        intent: '',
        published: false,
        isDeleted: false,
        isFunction: false,
        nodes: structuredClone(initialNodes),
        edges: structuredClone(initialEdges),
        utterances: []
    } as Chat,
    isDirty: false,
    isLoading: false
});

export default NodeStore;